import { toPath, get } from 'lodash';
import MissingPrivilegesError from '../../privileges/missing-privileges-error';
import { findExtensionByBaseUrl } from '../../privileges/privilege-resolver';
export function selectData(sourceData, selectors, messageType = 'datasetSubscribe', origin) {
    const extension = findExtensionByBaseUrl(origin !== null && origin !== void 0 ? origin : '');
    const permissionErrors = [];
    if (!selectors) {
        return sourceData;
    }
    const selectedData = selectors.reduce((acc, selector) => {
        // Check permissions for path entries
        ['', ...toPath(selector)].forEach((path) => {
            const value = path !== '' ? get(sourceData, path) : sourceData;
            let entityName = '';
            // @ts-expect-error - we just check if the value is an entity
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            if (value && value.__identifier__ && value.__identifier__() === 'Entity') {
                // @ts-expect-error - we know that the value is an entity
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                entityName = value.getEntityName();
            }
            // @ts-expect-error - we just check if the value is an entityCollection
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            if (value && value.__identifier__ && value.__identifier__() === 'EntityCollection') {
                // @ts-expect-error - we know that the value is an entityCollection
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                entityName = value.entity;
            }
            if (!entityName) {
                return;
            }
            const permissionsToCheck = ['read'];
            permissionsToCheck.forEach((privilege) => {
                const permissionsForPrivilege = extension === null || extension === void 0 ? void 0 : extension.permissions[privilege];
                if ((!permissionsForPrivilege ||
                    !permissionsForPrivilege.includes(entityName))
                    &&
                        !permissionErrors.includes(`${privilege}:${entityName}`)
                    &&
                        !(permissionsForPrivilege === null || permissionsForPrivilege === void 0 ? void 0 : permissionsForPrivilege.includes('*'))) {
                    permissionErrors.push(`${privilege}:${entityName}`);
                }
            });
        });
        const value = get(sourceData, selector);
        if (value !== undefined) {
            acc[selector] = value;
        }
        return acc;
    }, {});
    if (!extension) {
        console.warn(`No extension found for origin "${origin !== null && origin !== void 0 ? origin : ''}"`);
        return selectedData;
    }
    if (permissionErrors.length) {
        return new MissingPrivilegesError(messageType, permissionErrors);
    }
    return selectedData;
}
//# sourceMappingURL=selectData.js.map